export default __webpack_public_path__ + "static/media/NMAH.AC.0433_ref8166.cf23cce3.jpg";